import { forwardRef } from 'react';
import type { ButtonHTMLAttributes } from 'react';
import './Button.css';

type ButtonVariant = 'primary' | 'secondary' | 'glass';
type ButtonSize = 'touchline' | 'workbench';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'primary', size = 'touchline', className = '', children, ...rest },
  ref
) {
  return (
    <button
      ref={ref}
      data-variant={variant}
      data-size={size}
      className={`btn ${className}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );
});
